// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Document
 * ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in
 *    IE on Windows Phone and in iOS.
 */

html {
  line-height: 150%; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   * ========================================================================== */

/**
   * Correct the font size and margin on \`h1\` elements within \`section\` and
   * \`article\` contexts in Chrome, Edge, Firefox, and Safari.
   */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   * ========================================================================== */

/**
   * Remove the margin on nested lists in Chrome, Edge, IE, and Safari.
   */

dl dl,
dl ol,
dl ul,
ol dl,
ul dl {
  margin: 0;
}

/**
   * Remove the margin on nested lists in Edge 18- and IE.
   */

ol ol,
ol ul,
ul ol,
ul ul {
  margin: 0;
}

/**
   * 1. Add the correct box sizing in Firefox.
   * 2. Correct the inheritance of border color in Firefox.
   * 3. Show the overflow in Edge 18- and IE.
   */

hr {
  box-sizing: content-box; /* 1 */
  color: inherit; /* 2 */
  height: 0; /* 1 */
  overflow: visible; /* 3 */
}

/**
   * Add the correct display in IE.
   */

main {
  display: block;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   * ========================================================================== */

/**
   * Remove the gray background on active links in IE 10.
   */

a {
  background-color: transparent;
}

/**
   * Add the correct text decoration in Edge 18-, IE, and Safari.
   */

abbr[title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

b,
strong {
  font-weight: bolder;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
   * Add the correct font size in all browsers.
   */

small {
  font-size: 80%;
}

/* Embedded content
   * ========================================================================== */

/**
   * Add the correct display in IE 9-.
   */

audio,
video {
  display: inline-block;
}

/**
   * Add the correct display in iOS 4-7.
   */

audio:not([controls]) {
  display: none;
  height: 0;
}

/**
   * Remove the border on images within links in IE 10-.
   */

img {
  border-style: none;
}

/**
   * Hide the overflow in IE.
   */

svg:not(:root) {
  overflow: hidden;
}

/* Tabular data
   * ========================================================================== */

/**
   * 1. Correct table border color inheritance in all Chrome, Edge, and Safari.
   * 2. Remove text indentation from table contents in Chrome, Edge, and Safari.
   */

table {
  border-color: inherit; /* 1 */
  text-indent: 0; /* 2 */
}

/* Forms
   * ========================================================================== */

/**
   * Remove the margin on controls in Safari.
   */

button,
input,
select {
  margin: 0;
}

/**
   * 1. Show the overflow in IE.
   * 2. Remove the inheritance of text transform in Edge 18-, Firefox, and IE.
   */

button {
  overflow: visible; /* 1 */
  text-transform: none; /* 2 */
}

/**
   * Correct the inability to style buttons in iOS and Safari.
   */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
   * Correct the padding in Firefox.
   */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
   * Show the overflow in Edge 18- and IE.
   */

input {
  overflow: visible;
}

/**
   * 1. Correct the text wrapping in Edge 18- and IE.
   * 2. Correct the color inheritance from \`fieldset\` elements in IE.
   */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  white-space: normal; /* 1 */
}

/**
   * 1. Add the correct display in Edge 18- and IE.
   * 2. Add the correct vertical alignment in Chrome, Edge, and Firefox.
   */

progress {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}

/**
   * Remove the inheritance of text transform in Firefox.
   */

select {
  text-transform: none;
}

/**
   * 1. Remove the margin in Firefox and Safari.
   * 2. Remove the default vertical scrollbar in IE.
   */

textarea {
  margin: 0; /* 1 */
  overflow: auto; /* 2 */
}

/**
   * 1. Add the correct box sizing in IE 10-.
   * 2. Remove the padding in IE 10-.
   */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
   * 1. Correct the odd appearance in Chrome, Edge, and Safari.
   * 2. Correct the outline style in Safari.
   */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
   * Correct the cursor style of increment and decrement buttons in Safari.
   */

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/**
   * Correct the text style of placeholders in Chrome, Edge, and Safari.
   */

::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}

/**
   * Remove the inner padding in Chrome, Edge, and Safari on macOS.
   */

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * 1. Correct the inability to style upload buttons in iOS and Safari.
   * 2. Change font properties to \`inherit\` in Safari.
   */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/**
   * Remove the inner border and padding of focus outlines in Firefox.
   */

::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
   * Restore the focus outline styles unset by the previous rule in Firefox.
   */

:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
   * Remove the additional :invalid styles in Firefox.
   */

:-moz-ui-invalid {
  box-shadow: none;
}

/* Interactive
   * ========================================================================== */

/*
   * Add the correct display in Edge 18- and IE.
   */

details {
  display: block;
}

/*
   * Add the correct styles in Edge 18-, IE, and Safari.
   */

dialog {
  background-color: white;
  border: solid;
  color: black;
  display: block;
  height: -moz-fit-content;
  height: fit-content;
  left: 0;
  margin: auto;
  padding: 1em;
  position: absolute;
  right: 0;
  width: -moz-fit-content;
  width: fit-content;
}

dialog:not([open]) {
  display: none;
}

/*
   * Add the correct display in all browsers.
   */

summary {
  display: list-item;
}

/* Scripting
   * ========================================================================== */

/**
   * Add the correct display in IE 9-.
   */

canvas {
  display: inline-block;
}

/**
   * Add the correct display in IE.
   */

template {
  display: none;
}

/* User interaction
   * ========================================================================== */

/**
   * Add the correct display in IE 10-.
   */

[hidden] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/normalize.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;;;;EAIE;;AAEF;EACE,iBAAiB,EAAE,MAAM;EACzB,0BAA0B,EAAE,MAAM;EAClC,8BAA8B,EAAE,MAAM;AACxC;;AAEA;iFACiF;;AAEjF;;;IAGI;;AAEJ;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;;;;;EAKE,SAAS;AACX;;AAEA;;IAEI;;AAEJ;;;;EAIE,SAAS;AACX;;AAEA;;;;IAII;;AAEJ;EACE,uBAAuB,EAAE,MAAM;EAC/B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,iBAAiB,EAAE,MAAM;AAC3B;;AAEA;;IAEI;;AAEJ;EACE,cAAc;AAChB;;AAEA;;;IAGI;;AAEJ;EACE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;EACE,6BAA6B;AAC/B;;AAEA;;IAEI;;AAEJ;EACE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;;IAEI;;AAEJ;;EAEE,mBAAmB;AACrB;;AAEA;;;IAGI;;AAEJ;;;EAGE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;;AAEA;;IAEI;;AAEJ;EACE,cAAc;AAChB;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;;EAEE,qBAAqB;AACvB;;AAEA;;IAEI;;AAEJ;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;IAEI;;AAEJ;EACE,kBAAkB;AACpB;;AAEA;;IAEI;;AAEJ;EACE,gBAAgB;AAClB;;AAEA;iFACiF;;AAEjF;;;IAGI;;AAEJ;EACE,qBAAqB,EAAE,MAAM;EAC7B,cAAc,EAAE,MAAM;AACxB;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;;;EAGE,SAAS;AACX;;AAEA;;;IAGI;;AAEJ;EACE,iBAAiB,EAAE,MAAM;EACzB,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;IAEI;;AAEJ;;;;EAIE,0BAA0B;AAC5B;;AAEA;;IAEI;;AAEJ;EACE,8BAA8B;AAChC;;AAEA;;IAEI;;AAEJ;EACE,iBAAiB;AACnB;;AAEA;;;IAGI;;AAEJ;EACE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;EACtB,cAAc,EAAE,MAAM;EACtB,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;AAC7B;;AAEA;;;IAGI;;AAEJ;EACE,qBAAqB,EAAE,MAAM;EAC7B,wBAAwB,EAAE,MAAM;AAClC;;AAEA;;IAEI;;AAEJ;EACE,oBAAoB;AACtB;;AAEA;;;IAGI;;AAEJ;EACE,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;AACxB;;AAEA;;;IAGI;;AAEJ;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,UAAU,EAAE,MAAM;AACpB;;AAEA;;;IAGI;;AAEJ;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;IAEI;;AAEJ;;EAEE,YAAY;AACd;;AAEA;;IAEI;;AAEJ;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;IAEI;;AAEJ;EACE,wBAAwB;AAC1B;;AAEA;;;IAGI;;AAEJ;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;AAEA;;IAEI;;AAEJ;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;IAEI;;AAEJ;EACE,8BAA8B;AAChC;;AAEA;;IAEI;;AAEJ;EACE,gBAAgB;AAClB;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;EACE,cAAc;AAChB;;AAEA;;IAEI;;AAEJ;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,wBAAwB;EAExB,mBAAmB;EACnB,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EAEvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;IAEI;;AAEJ;EACE,kBAAkB;AACpB;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;EACE,qBAAqB;AACvB;;AAEA;;IAEI;;AAEJ;EACE,aAAa;AACf;;AAEA;iFACiF;;AAEjF;;IAEI;;AAEJ;EACE,aAAa;AACf","sourcesContent":["/* Document\n * ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\nhtml {\n  line-height: 150%; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   * ========================================================================== */\n\n/**\n   * Correct the font size and margin on `h1` elements within `section` and\n   * `article` contexts in Chrome, Edge, Firefox, and Safari.\n   */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   * ========================================================================== */\n\n/**\n   * Remove the margin on nested lists in Chrome, Edge, IE, and Safari.\n   */\n\ndl dl,\ndl ol,\ndl ul,\nol dl,\nul dl {\n  margin: 0;\n}\n\n/**\n   * Remove the margin on nested lists in Edge 18- and IE.\n   */\n\nol ol,\nol ul,\nul ol,\nul ul {\n  margin: 0;\n}\n\n/**\n   * 1. Add the correct box sizing in Firefox.\n   * 2. Correct the inheritance of border color in Firefox.\n   * 3. Show the overflow in Edge 18- and IE.\n   */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  color: inherit; /* 2 */\n  height: 0; /* 1 */\n  overflow: visible; /* 3 */\n}\n\n/**\n   * Add the correct display in IE.\n   */\n\nmain {\n  display: block;\n}\n\n/**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   * ========================================================================== */\n\n/**\n   * Remove the gray background on active links in IE 10.\n   */\n\na {\n  background-color: transparent;\n}\n\n/**\n   * Add the correct text decoration in Edge 18-, IE, and Safari.\n   */\n\nabbr[title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\n\n/**\n   * Add the correct font weight in Chrome, Edge, and Safari.\n   */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n   * Add the correct font size in all browsers.\n   */\n\nsmall {\n  font-size: 80%;\n}\n\n/* Embedded content\n   * ========================================================================== */\n\n/**\n   * Add the correct display in IE 9-.\n   */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n   * Add the correct display in iOS 4-7.\n   */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n   * Remove the border on images within links in IE 10-.\n   */\n\nimg {\n  border-style: none;\n}\n\n/**\n   * Hide the overflow in IE.\n   */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Tabular data\n   * ========================================================================== */\n\n/**\n   * 1. Correct table border color inheritance in all Chrome, Edge, and Safari.\n   * 2. Remove text indentation from table contents in Chrome, Edge, and Safari.\n   */\n\ntable {\n  border-color: inherit; /* 1 */\n  text-indent: 0; /* 2 */\n}\n\n/* Forms\n   * ========================================================================== */\n\n/**\n   * Remove the margin on controls in Safari.\n   */\n\nbutton,\ninput,\nselect {\n  margin: 0;\n}\n\n/**\n   * 1. Show the overflow in IE.\n   * 2. Remove the inheritance of text transform in Edge 18-, Firefox, and IE.\n   */\n\nbutton {\n  overflow: visible; /* 1 */\n  text-transform: none; /* 2 */\n}\n\n/**\n   * Correct the inability to style buttons in iOS and Safari.\n   */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n   * Correct the padding in Firefox.\n   */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n   * Show the overflow in Edge 18- and IE.\n   */\n\ninput {\n  overflow: visible;\n}\n\n/**\n   * 1. Correct the text wrapping in Edge 18- and IE.\n   * 2. Correct the color inheritance from `fieldset` elements in IE.\n   */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  white-space: normal; /* 1 */\n}\n\n/**\n   * 1. Add the correct display in Edge 18- and IE.\n   * 2. Add the correct vertical alignment in Chrome, Edge, and Firefox.\n   */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n   * Remove the inheritance of text transform in Firefox.\n   */\n\nselect {\n  text-transform: none;\n}\n\n/**\n   * 1. Remove the margin in Firefox and Safari.\n   * 2. Remove the default vertical scrollbar in IE.\n   */\n\ntextarea {\n  margin: 0; /* 1 */\n  overflow: auto; /* 2 */\n}\n\n/**\n   * 1. Add the correct box sizing in IE 10-.\n   * 2. Remove the padding in IE 10-.\n   */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n   * 1. Correct the odd appearance in Chrome, Edge, and Safari.\n   * 2. Correct the outline style in Safari.\n   */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n   * Correct the cursor style of increment and decrement buttons in Safari.\n   */\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n   * Correct the text style of placeholders in Chrome, Edge, and Safari.\n   */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n   * Remove the inner padding in Chrome, Edge, and Safari on macOS.\n   */\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * 1. Correct the inability to style upload buttons in iOS and Safari.\n   * 2. Change font properties to `inherit` in Safari.\n   */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/**\n   * Remove the inner border and padding of focus outlines in Firefox.\n   */\n\n::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n   * Restore the focus outline styles unset by the previous rule in Firefox.\n   */\n\n:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n   * Remove the additional :invalid styles in Firefox.\n   */\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/* Interactive\n   * ========================================================================== */\n\n/*\n   * Add the correct display in Edge 18- and IE.\n   */\n\ndetails {\n  display: block;\n}\n\n/*\n   * Add the correct styles in Edge 18-, IE, and Safari.\n   */\n\ndialog {\n  background-color: white;\n  border: solid;\n  color: black;\n  display: block;\n  height: -moz-fit-content;\n  height: -webkit-fit-content;\n  height: fit-content;\n  left: 0;\n  margin: auto;\n  padding: 1em;\n  position: absolute;\n  right: 0;\n  width: -moz-fit-content;\n  width: -webkit-fit-content;\n  width: fit-content;\n}\n\ndialog:not([open]) {\n  display: none;\n}\n\n/*\n   * Add the correct display in all browsers.\n   */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   * ========================================================================== */\n\n/**\n   * Add the correct display in IE 9-.\n   */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n   * Add the correct display in IE.\n   */\n\ntemplate {\n  display: none;\n}\n\n/* User interaction\n   * ========================================================================== */\n\n/**\n   * Add the correct display in IE 10-.\n   */\n\n[hidden] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
